<template src="./index.html"></template>
<style src="./style.scss" lang="scss" scoped></style>
<script>
import Background from '@/components/Background';
import Navbar from '@/components/Navbar';
import NumberCard from './components/NumberCard';
import BackButton from '@/components/BackButton';

export default {
  name: 'Numbers',
  components: { Background, Navbar, NumberCard, BackButton },
  data() {
    return {
      cards: [
        {
          type: 'tollfree',
          title: 'Toll Free Numbers',
          description: `Give your business a national presence.`
        },
        {
          type: 'local',
          title: 'Local Numbers',
          description: `Choose the perfect area code to connect with your community.`
        },
        {
          type: 'porting',
          title: 'Number Porting',
          description: `Already have a phone number? Transfer it to Voyyp.`
        }
      ]
    };
  },

  methods: {
    onSelect(card) {
      this.$router.push('/numbers/search?type=' + card.type);
    }
  }
};
</script>
 